<div #stickyWrapper class="sticky-wrapper" [ngClass]="{'stick-to-bottom': stickToBottom}" [ngStyle]="{'bottom.px': bottomOffset}">
	<ng-content></ng-content>
</div>
